module.exports = __webpack_public_path__ + "static/media/c8bannerModul1_small.17ebe8dd.jpg";